var _a;
import { UnitSuffix } from '../../defs';
import { noConvert } from '../../internal/converters';
var magnificationToPercent = function (value) {
    return value * 100;
};
export var magnification = (_a = {},
    _a[UnitSuffix.Percent] = magnificationToPercent,
    _a[UnitSuffix.Magnification] = noConvert,
    _a);
//# sourceMappingURL=magnification.js.map